export default class ManageErrorMessages {
	constructor({notify, message, that}) {
		this.notify = notify;
		this.errorMessage = message || "No found message";
		this.that = that;
	}

	setErrorMessage(errorMessage) {
		const errors = {
			"auth/wrong-password": this.that.$t("Login.ValidMessages.InvalidPassword"),
			"auth/user-not-found": this.that.$t("Login.ValidMessages.UserNotFound"),
			"auth/too-many-requests": this.that.$t("Login.ValidMessages.TooManyRequests"),
			"Resource are empty": this.that.$t("Login.ValidMessages.UserNotFound"),
			"Resource is not ACTIVE": this.that.$t("Login.Disabled"),
		};

		this.errorMessage = errors[errorMessage] ? errors[errorMessage] : this.that.$t("Error");
	}

	showMessage() {
		this.that.$vs.notify({
			time: 7000,
			title: "Error",
			text: this.errorMessage,
			iconPack: "feather",
			icon: "icon-alert-circle",
			color: "danger",
		});
	}
	processError(err) {
		let text = this.that.$t("ErrorMessage");
		if (err.message === "missing fields: ['address']") {
			text = this.that.$t("VisitPoints.ErrorFindAddress.Text");
		}
		if (err.message === "Not georreferencer address") {
			text = this.that.$t("VisitPoints.AddressCouldBeNotGeoreferenced");
		}
		if (err.data) {
			if (err.data.reason === "Sitidata api georeversed token not enabled for this company.") {
				text = this.that.$t("VisitPoints.SitidataGeoreverseToken");
			} else if (err.data.reason === "Sitidata api not enabled for this company.") {
				text = this.that.$t("VisitPoints.SitidataNoEnabled");
			}
		}
		this.that.$vs.notify({
			color: "danger",
			title: this.that.$t("VisitPoints.Georeferencer"),
			text,
			time: 5000,
		});
	}
	processErrorOptimizerManager(err) {
		let text = this.that.$t("ErrorMessage");
		if (err.message === "the optimization_api already exists for the company.") {
			text = this.that.$t("OptimizerManager.ErrorMessage.TheOptimizationApiAlreadyExistsForTheEnterprise");
		} else if (err.message === "api_key is not required for this optimization_api.") {
			text = this.that.$t("OptimizerManager.ErrorMessage.ApiKeyIsNotRequiredForThisOptimizationApi");
		} else if (err.message === "not a valid date.") {
			text = this.that.$t("OptimizerManager.ErrorMessage.NotAValidDate");
		} else if (err.message === "date less than current date.") {
			text = this.that.$t("OptimizerManager.ErrorMessage.DateLessThanCurrentDate");
		} else if (err.message.includes("is too short") && !message.includes("[]")) {
			return this.that.$t("Setting.TooShortProperties") + ". " + this.that.$t("Setting.ReviewValues");
		} else if (err.message.includes("[] is too short")) {
			return this.that.$t("DesignConfig.SelectMinimumOneOption");
		} else if (err.message.includes("is not one of")) {
			return this.that.$t("DesignConfig.SelectMinimumOneOption");
		} else if (err.message.includes("is not of type 'string'")) {
			return this.that.$t("Setting.IsNotStringValid");
		} else if (err.message.includes("is greater than the maximum")) {
			return this.that.$t("Setting.IsGreaterThanMaximum") + ". " + this.that.$t("Setting.ReviewValues");
		} else if (err.message.includes("is less than the minimum")) {
			return this.that.$t("Setting.IsLessThanMinimum") + ". " + this.that.$t("Setting.ReviewValues");
		} else if (err.message.includes("is too long")) {
			return this.that.$t("Setting.IsTooLong") + ". " + this.that.$t("Setting.ReviewValues");
		}
		this.that.$vs.notify({
			color: "warning",
			title: this.that.$t("ErrorTitle"),
			text,
			time: 7000,
		});
	}
}
